// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file inventory/v1/assessment_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import { AssessmentService } from "./assessment_service_pb";

/**
 * @generated from rpc inventory.v1.AssessmentService.StartAssessment
 */
export const startAssessment = AssessmentService.method.startAssessment;

/**
 * @generated from rpc inventory.v1.AssessmentService.FinalizeAssessment
 */
export const finalizeAssessment = AssessmentService.method.finalizeAssessment;

/**
 * @generated from rpc inventory.v1.AssessmentService.ListAssessments
 */
export const listAssessments = AssessmentService.method.listAssessments;

/**
 * @generated from rpc inventory.v1.AssessmentService.ListOngoingAssessments
 */
export const listOngoingAssessments = AssessmentService.method.listOngoingAssessments;

/**
 * @generated from rpc inventory.v1.AssessmentService.GetOngoingAssessment
 */
export const getOngoingAssessment = AssessmentService.method.getOngoingAssessment;

/**
 * @generated from rpc inventory.v1.AssessmentService.GetAssessment
 */
export const getAssessment = AssessmentService.method.getAssessment;

/**
 * @generated from rpc inventory.v1.AssessmentService.GetRoomByAssessmentId
 */
export const getRoomByAssessmentId = AssessmentService.method.getRoomByAssessmentId;

/**
 * @generated from rpc inventory.v1.AssessmentService.GetToken
 */
export const getToken = AssessmentService.method.getToken;

/**
 * @generated from rpc inventory.v1.AssessmentService.ListProjects
 */
export const listProjects = AssessmentService.method.listProjects;

/**
 * @generated from rpc inventory.v1.AssessmentService.GetProject
 */
export const getProject = AssessmentService.method.getProject;

/**
 * @generated from rpc inventory.v1.AssessmentService.ListAssessmentCadenceSettings
 */
export const listAssessmentCadenceSettings = AssessmentService.method.listAssessmentCadenceSettings;

/**
 * @generated from rpc inventory.v1.AssessmentService.GetAssessmentNotesYdoc
 */
export const getAssessmentNotesYdoc = AssessmentService.method.getAssessmentNotesYdoc;

/**
 * @generated from rpc inventory.v1.AssessmentService.SetAssessmentCadenceSetting
 */
export const setAssessmentCadenceSetting = AssessmentService.method.setAssessmentCadenceSetting;

/**
 * @generated from rpc inventory.v1.AssessmentService.ListAssessmentScoreLabels
 */
export const listAssessmentScoreLabels = AssessmentService.method.listAssessmentScoreLabels;

/**
 * @generated from rpc inventory.v1.AssessmentService.SetAssessmentScoreLabels
 */
export const setAssessmentScoreLabels = AssessmentService.method.setAssessmentScoreLabels;

/**
 * @generated from rpc inventory.v1.AssessmentService.DeleteAssessmentScoreLabels
 */
export const deleteAssessmentScoreLabels = AssessmentService.method.deleteAssessmentScoreLabels;

/**
 * @generated from rpc inventory.v1.AssessmentService.CreateProject
 */
export const createProject = AssessmentService.method.createProject;

/**
 * @generated from rpc inventory.v1.AssessmentService.DeleteProject
 */
export const deleteProject = AssessmentService.method.deleteProject;

/**
 * @generated from rpc inventory.v1.AssessmentService.UpdateProjectName
 */
export const updateProjectName = AssessmentService.method.updateProjectName;

/**
 * @generated from rpc inventory.v1.AssessmentService.SetProjectMember
 */
export const setProjectMember = AssessmentService.method.setProjectMember;

/**
 * @generated from rpc inventory.v1.AssessmentService.SetProjectControlScope
 */
export const setProjectControlScope = AssessmentService.method.setProjectControlScope;

/**
 * @generated from rpc inventory.v1.AssessmentService.UpdateAssessmentDueDate
 */
export const updateAssessmentDueDate = AssessmentService.method.updateAssessmentDueDate;

/**
 * @generated from rpc inventory.v1.AssessmentService.DeleteOngoingAssessment
 */
export const deleteOngoingAssessment = AssessmentService.method.deleteOngoingAssessment;

/**
 * @generated from rpc inventory.v1.AssessmentService.AddOngoingAssessmentAssignee
 */
export const addOngoingAssessmentAssignee = AssessmentService.method.addOngoingAssessmentAssignee;

/**
 * @generated from rpc inventory.v1.AssessmentService.RemoveOngoingAssessmentAssignee
 */
export const removeOngoingAssessmentAssignee = AssessmentService.method.removeOngoingAssessmentAssignee;

/**
 * SubmitAssessmentForApproval moves an ongoing assessment from IN_PROGRESS to
 * AWAITING_APPROVAL, records the caller as concluded_by, and triggers report
 * generation.
 *
 * @generated from rpc inventory.v1.AssessmentService.SubmitAssessmentForApproval
 */
export const submitAssessmentForApproval = AssessmentService.method.submitAssessmentForApproval;
